__turbopack_context__.v({
  "menu_list_content": "menu-module-scss-module__v2Tf8q__menu_list_content",
  "menu_list_padding": "menu-module-scss-module__v2Tf8q__menu_list_padding",
  "my_section_divider": "menu-module-scss-module__v2Tf8q__my_section_divider",
  "my_section_list": "menu-module-scss-module__v2Tf8q__my_section_list",
});
